import { RULES, MESSAGES } from './constants'

const validateField = ({
  type,
  value,
  values,
  decorate,
  passValues,
  rule = type,
  checkValidity,
  message = MESSAGES[type]
}) => {
  const checker = decorate ? checkValidity(RULES[rule]) :
    checkValidity || RULES[rule]

  const isValid = typeof checker === 'function' ? checker(passValues ? values : value) : checker.test(value)

  return isValid ? '' : message
}

export default descriptors => values =>
  Object
    .keys(descriptors)
    .reduce((errors, field) => {
      const descriptor = descriptors[field]
      const value = values[field] || ''

      return {
        ...errors,
        [field]: Array.isArray(descriptor) ?
          descriptor.reduce((currentMessage, nextFieldDescriptor) =>
            validateField({ ...nextFieldDescriptor, value, values }) || currentMessage, '') :
          validateField({ ...descriptor, value, values })
      }
    }, {})
